
/**
 * @class
 * @classdesc Base class for creating trackers like Google Analytics, Piwik and others.
 *
 * @param {Object} hcs - HCS instance
 */
export default class TrackingBase
{
    constructor(paramObj) {
        this.hcs = paramObj.hcs;
    }

    /**
     * Write data to tracking engine.
     * @param {TrackingTypes} trackingType - Specify type of data. See the {@link TrackingTypes} enum for possible values.
     * @param {Object|Array} [data] - Data object being written to tracker.
     * The art of data is not relevant since it must be converted for desired tracking API in subclass.
     * The current suggestion is either a single JSON object as key/value pair
     * 
     * @example <caption>Example with single data object</caption>
     * { "myAttribute": "myValue" }
     * 
     * @example <caption>Example with object array</caption>
     * [
     *     { "myAttribute1": "myValue1" }
     *     { "myAttribute2": "myValue2" }
     */
    track(trackingType, data) {
        this._pushData(trackingType, data);
    }

    /**
     * Finally write data to tracker.
     * Override this function and (optionally) convert the given data object
     * to a format the target tracker understands.
     * @param {Object} data - Data arguments being written to tracker.
     */
    _pushData(trackingType, data) { }
}

export const TrackingTypes = Object.freeze({
    Toolbar: "Toolbar",
    Config: "Config",
    Placement: "Placement",
    Progress: "Progress",
    Shop: "Shop",
    ShareLink: "ShareLink",
    Output: "Output",
    LoadConfiguration: "LoadConfiguration"
});